import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57f274c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalBackdrop flex absolute z-max" }
const _hoisted_2 = { class: "c4c-modal" }
const _hoisted_3 = { class: "panelheader" }
const _hoisted_4 = { class: "headerTitle" }
const _hoisted_5 = { "aria-hidden": "true" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text" }, "Close", -1))
const _hoisted_7 = {
  key: 0,
  id: "departmentModal",
  class: "panleBody scrollBar border"
}
const _hoisted_8 = { class: "float-right mb-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", {
  id: "departmentTable",
  class: "table-hover dashboardTable sevenDaydashboardTable",
  style: {"height":"auto"}
}, [
  /*#__PURE__*/_createElementVNode("colgroup", { id: "departmentColGroupTbl" }),
  /*#__PURE__*/_createElementVNode("thead", { id: "departmentHeaderTbl" }),
  /*#__PURE__*/_createElementVNode("tbody", { id: "departmentBodyTbl" })
], -1))
const _hoisted_10 = {
  key: 1,
  class: "txtCenter"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.headerDetails.FacilityName) + " - " + _toDisplayString(_ctx.headerDetails.ClusterName) + " - (" + _toDisplayString(_ctx.headerDetails.ShiftTime) + ")", 1),
        _createElementVNode("a", {
          href: "#",
          class: "closeBtn neu-tooltip",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, [
          _createElementVNode("i", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'close'],
              size: "lg"
            })
          ]),
          _hoisted_6
        ])
      ]),
      (_ctx.departmentList != null && _ctx.departmentList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createElementVNode("h6", _hoisted_8, "Skills: " + _toDisplayString(_ctx.deptSkills.join(', ')), 1)
            ]),
            _hoisted_9
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, "No data available."))
    ])
  ]))
}